"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = exports.useTheme = void 0;
const unstated_next_1 = require("unstated-next");
const react_1 = require("react");
const index_1 = require("../../Theming/index");
const typestyle_1 = require("typestyle");
const useThemesStateContainer = unstated_next_1.createContainer(() => {
    const [theme, setTheme] = react_1.useState(index_1.MainTheme);
    const themed = (themeKey) => (className) => [className, typestyle_1.style(theme[themeKey])].join(' ');
    return { theme, setTheme, themed };
});
exports.useTheme = useThemesStateContainer.useContainer;
exports.ThemeProvider = useThemesStateContainer.Provider;
